import { useQuery, useQueryClient } from '@tanstack/react-query'
import { supabase } from '../../../lib/supabase'
import { useAuth } from '../../../hooks/useAuth'

export const useShoppingLists = () => {
  const { household, user } = useAuth()
  const qc  = useQueryClient()
  const key = ['shopping-lists', household?.id]

  const query = useQuery({
    queryKey: key,
    enabled:  !!household?.id,
    queryFn:  async () => {
      const { data, error } = await supabase
        .from('shopping_lists')
        .select('id, name, created_by, created_at')
        .eq('household_id', household.id)
        .order('created_at', { ascending: false })
      if (error) throw error
      return data ?? []
    },
  })

  const invalidate = () => qc.invalidateQueries({ queryKey: key })

  const createList = async (name) => {
    const { data, error } = await supabase
      .from('shopping_lists')
      .insert({ name, household_id: household.id, created_by: user.id })
      .select()
      .single()
    if (error) throw error
    invalidate()
    return data
  }

  const deleteList = async (id) => {
    const { error } = await supabase.from('shopping_lists').delete().eq('id', id)
    if (error) throw error
    invalidate()
  }

  return { ...query, createList, deleteList }
}
